import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  sppdProyekService = {}

sppdProyekService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/sppd/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

sppdProyekService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/sppd/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

sppdProyekService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/sppd/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

sppdProyekService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/sppd/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}


export default sppdProyekService;
